<template>
    <div class="slider-bar-wrap"
         :class="{ collapsed }"
         @mouseenter="collapsed = false"
         @mouseleave="collapsed = true">
        <div class="tool-left">
            <a-icon type="menu-unfold" class="tool-left-icon" />
            <p>在线客服</p>
        </div>
        <div class="tool-right">
            <div class="tool" @click="openCustomerService">
                <a-icon type="message" theme="filled" class="tool-icon" />
                <div class="tool-text">在线咨询</div>
            </div>
            <div class="tool">
                <div style="overflow: auto">
                    <a-icon type="phone" theme="filled" class="tool-icon" />
                    <div class="tool-text tool-hotline">服务热线</div>
                </div>
                <div class="tool-phone">400-800-5100</div>
            </div>
            <div v-show="!!operationFileUrl" class="tool" @click="openOperationFile">
                <a-icon type="read" theme="filled" class="tool-icon" />
                <div class="tool-text">操作手册</div>
            </div>
            <div class="tool" @click="toTop">
                <a-icon type="caret-up" theme="filled" class="tool-icon" />
                <div style="margin-right: 36px;" class="tool-text tool-top">置顶</div>
            </div>
        </div>
    </div>
</template>

<script>
import { Icon } from 'ant-design-vue'

export default {
    name: 'SliderBar',
    components: {
        AIcon: Icon
    },
    props: {
        text: {
            type: String
        }
    },
    data() {
        return {
            collapsed: true
        }
    },
    computed: {
        operationFileUrl() {
            return this.$store.getters.initInformation?.entDocUrl
        }
    },
    methods: {
        openCustomerService() {
            if (window.isSdkReady) {
                window.ysf('open')
            } else {
                this.$message.warning('sdk尚未加载成功，请稍后再试')
            }
        },
        openOperationFile() {
            const { operationFileUrl } = this
            if (operationFileUrl) {
                window.open(operationFileUrl)
            } else {
                this.$message.warn('操作手册未配置')
            }
        },
        toTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.slider-bar-wrap {
    position: fixed;
    top: 35%;
    z-index: 99;
    right: 0;
    transition: right 0.3s ease-out;
    display: table;
    border-collapse: collapse;
    user-select: none;
    box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);

    &.collapsed {
        right: -140px;
    }

    .tool-left {
        position: relative;
        display: table-cell;
        vertical-align: middle;
        width: 14px;
        padding: 0 10px;
        background: #2e80e9;
        border-radius: 6px 0 0 6px;
        font-size: 16px;
        color: #fff;
        line-height: 20px;
        cursor: pointer;

        .tool-left-icon {
            position: absolute;
            top: 8px;
            left: 50%;
            transform: translateX(-50%);
            font-size: 16px;
        }
    }

    .tool-right {
        display: table-cell;
        width: 140px;

        .tool {
            cursor: pointer;
            box-sizing: content-box;
            padding: 9px 14px;
            overflow: auto;
            background: #fff;
            border-bottom: 1px solid #e1e1e1;

            .tool-phone {
                font-size: 18px;
                font-family: DINAlternate-Bold, DINAlternate;
                font-weight: bold;
                color: #999;
                margin-left: 10px;
            }

            .tool-text {
                float: right;
                height: 20px;
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFng SC;
                font-weight: 500;
                line-height: 20px;
                color: #555;
                letter-spacing: 4px;
                margin-top: 5px;
            }

             .tool-icon {
                font-size: 18px;
                line-height: 30px;
                color: #2e80e9;
                margin-top: 2px;
                float: left;
            }
        }
    }
}

</style>
